export default __webpack_public_path__ + "static/media/logo vertical instituto ronald.66914e36.png";